export default __webpack_public_path__ + "static/media/samsung.849da219.svg";